import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const cancelPersonFromProject = createAsyncThunk(
    "project/cancelPersonFromProject",
    async ({ projectid, personid }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token"); // assuming JWT auth
            const res = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/manager-action-cancel`,
                { projectid, personid },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to cancel person from project"
            );
        }
    }
);

export const cancelPersonFromProjectAssign = createAsyncThunk(
    "project/cancelPersonFromProjectAssign",
    async ({ projectid, personid }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token"); // assuming JWT auth
            const res = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/manager-action-cancel-track`,
                { projectid, personid },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to cancel person from project"
            );
        }
    }
);

const cancelPersonSlice = createSlice({
    name: "cancelPerson",
    initialState: {
        loading: false,
        success: false,
        error: null,
        message: null,
    },
    reducers: {
        resetCancelPersonState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.message = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(cancelPersonFromProject.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
                state.message = null;
            })
            .addCase(cancelPersonFromProject.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload.message;
            })
            .addCase(cancelPersonFromProject.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            })

            .addCase(cancelPersonFromProjectAssign.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
                state.message = null;
            })
            .addCase(cancelPersonFromProjectAssign.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload.message;
            })
            .addCase(cancelPersonFromProjectAssign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    },
});

export const { resetCancelPersonState } = cancelPersonSlice.actions;
export default cancelPersonSlice.reducer;
